"use client";

import { useEffect, useState } from "react";
import { IconTag } from "@tabler/icons-react";

interface PackageMetaProps {
  packages: string[];
  initialData?: {
    title: string;
    description: string;
    category: string;
    tags: string[];
  };
}

export default function PackageMeta({ packages, initialData }: PackageMetaProps) {
  if (!initialData) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg border border-[#E5E5E5] p-6 space-y-4">
      <h1 className="text-2xl font-bold">{initialData.title}</h1>
      <p className="text-gray-600">{initialData.description}</p>
      <div className="flex flex-wrap gap-4 items-center">
        <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
          {initialData.category}
        </span>
        {initialData.tags.map((tag) => (
          <span
            key={tag}
            className="flex items-center gap-1 px-2 py-1 bg-gray-100 text-gray-600 rounded text-sm"
          >
            <IconTag size={14} />
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
